import React from 'react';
import { styled } from 'linaria/lib/react';
import Link from 'next/link';
import { Flex, theme } from '@mtsbank/ui-kit';
import { Spacer } from '@root/components/Uikit/Spacer';
import { ICON_TCP } from '../constansts';
interface Props {
  title: string;
  onClick?: () => void;
  icon?: string;
  slider?: boolean;
  // merchant?: string
  url?: string;
}
const NEWS_SERVICES = [
// 'identity-v',
'arena-breakout',
// 'watcher-of-realms',
// 'tower-of-fantasy',
// 'lifeafter',
'dragonheir-silent-gods', 'super-sus',
// 'goddess-of-victory-nikke',
'state-of-survival-zombie-war',
// 'farlight-84',
// 'harry-potter-magic-awakened',
'onmyoji-arena',
// 'free-fire',
'honkai-star-rail',
// 'tarisland',
'zenless-zone-zero'
// 'garena-free-fire-garena',
// 'mobile-legends-bang-bang',
];
export const TileButton = ({
  title,
  onClick,
  icon,
  slider,
  url
}: Props) => <Flex direction="column">
    <Link passHref href={`/${url}`}>
      <ButtonWrraper onClick={onClick}>
        <Button slider={slider} hasIcon={!!icon} icon={icon} />
        {/* {slider && merchant && (
          <ComissionInfo>
            <div className="wrapper-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.99995 15.0007C11.0937 15.0007 13.4999 12.559 13.4999 9.41106C13.4999 7.72609 12.5134 6.45443 11.5229 5.17751C10.7584 4.19203 9.99148 3.20343 9.67373 2.01928C9.46814 1.2531 8.63499 0.677153 8.03223 1.19289C7.10014 1.99041 6.24699 3.10266 5.56276 4.50154C5.53065 4.45209 5.49862 4.40194 5.46671 4.35106C5.1877 3.90622 4.51957 3.87477 4.25664 4.32931C3.19152 6.17059 2.73877 7.39993 2.57689 8.41797C2.5252 8.64717 2.5001 8.96201 2.5 9.40837V9.41106C2.5 12.559 4.90622 15.0007 7.99995 15.0007ZM9.25842 9.68664C9.66813 10.2691 9.99988 10.7408 9.99988 11.6042C9.99988 12.6875 9.19311 13.5 8.02507 13.5C6.85702 13.5 5.99988 12.6875 5.99988 11.6042C5.99988 9.78347 7.00145 8.10648 8.02507 7C8.33542 8.37437 8.83797 9.08887 9.25842 9.68664Z"
                  fill="#FF8A00"
                />
              </svg>
            </div>
            <TextComissionDesktop>Комиссия всего 10%</TextComissionDesktop>
            <TextComissionMobile>Комиссия 10%</TextComissionMobile>
          </ComissionInfo>
         )} */}
        {NEWS_SERVICES.includes(url) && <ComissionInfo>
            <div className="wrapper-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M8.00007 15.9812C11.0938 15.9812 13.5 13.5394 13.5 10.3915C13.5 8.70656 12.5136 7.4349 11.523 6.15798C10.7585 5.1725 9.9916 4.18389 9.67386 2.99975C9.46826 2.23357 8.63511 1.65762 8.03235 2.17336C7.10026 2.97088 6.24711 4.08313 5.56289 5.48201C5.53077 5.43255 5.49875 5.38241 5.46684 5.33153C5.18782 4.88669 4.51969 4.85524 4.25676 5.30977C3.19165 7.15106 2.73889 8.3804 2.57701 9.39844C2.52533 9.62764 2.50022 9.94248 2.50012 10.3888V10.3915C2.50012 13.5394 4.90634 15.9812 8.00007 15.9812ZM9.25855 10.6671C9.66825 11.2496 10 11.7213 10 12.5846C10 13.668 9.19323 14.4805 8.02519 14.4805C6.85714 14.4805 6 13.668 6 12.5846C6 10.7639 7.00157 9.08695 8.02519 7.98047C8.33554 9.35484 8.83809 10.0693 9.25855 10.6671Z" fill="#FAC031" />
              </svg>
            </div>
            <TextComissionDesktop>Новинка</TextComissionDesktop>
            {/* <TextComissionMobile>Скидка на год 30%</TextComissionMobile> */}
          </ComissionInfo>}
      </ButtonWrraper>
    </Link>
    <Spacer space={12} spacemob={12} />
    <CustomFlex>
      <Text>{title}</Text>
    </CustomFlex>
  </Flex>;
const Button = /*#__PURE__*/styled("div")({
  name: "Button",
  class: "bpz9ct5",
  vars: {
    "bpz9ct5-0": [({
      icon
    }) => icon ? `url(${ICON_TCP}${icon})` : 'none']
  }
});
const ButtonWrraper = /*#__PURE__*/styled("a")({
  name: "ButtonWrraper",
  class: "b8pqcwm"
});
const Text = /*#__PURE__*/styled("div")({
  name: "Text",
  class: "t1wm6zwl"
});
const CustomFlex = /*#__PURE__*/styled("div")({
  name: "CustomFlex",
  class: "clhkgl9"
});
const ComissionInfo = /*#__PURE__*/styled("div")({
  name: "ComissionInfo",
  class: "cc7r35m"
});
const TextComissionDesktop = /*#__PURE__*/styled("div")({
  name: "TextComissionDesktop",
  class: "t1ofcfa8"
});

// const TextComissionMobile = styled.div`
//   font-family: 'MTS Compact';
//   font-size: 12px;
//   font-style: normal;
//   font-weight: 500;
//   line-height: 16px;
//   color: #fafafa;
//   text-transform: none;

//   @media (min-width: 375px) {
//     display: none;
//   }
// `

require("./TileButton.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./TileButton.tsx");